import { render, staticRenderFns } from "./Download_h5.vue?vue&type=template&id=2a2c7ef4&scoped=true&"
import script from "./Download_h5.vue?vue&type=script&lang=js&"
export * from "./Download_h5.vue?vue&type=script&lang=js&"
import style0 from "./Download_h5.vue?vue&type=style&index=0&id=2a2c7ef4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2c7ef4",
  null
  
)

export default component.exports